export interface WebsiteConfig {
  title: string;
  description: string;
  author: string;
  coverImage: string;
  logo: string;
  /**
   * Specifying a valid BCP 47 language helps screen readers announce text properly.
   * See: https://dequeuniversity.com/rules/axe/2.2/valid-lang
   */
  lang: string;
  /**
   * blog full path, no ending slash!
   */
  siteUrl: string;
  /**
   * full url, no username
   */
  facebook?: string;
  linkedin?: string;
  github?: string;
  twitter?: string;
  showSubscribe: boolean;
}

const config: WebsiteConfig = {
  title: 'Nicknacks',
  author: 'Nicholas Vincent-Hill',
  description: 'by Nick Vincent-Hill',
  coverImage: 'img/home_background.jpg',
  logo: 'img/logo.png',
  lang: 'en',
  siteUrl: 'https://nicknacks.tech',
  linkedin: 'https://www.linkedin.com/in/nvincenthill',
  github: 'https://github.com/nvincenthill',
  showSubscribe: false,
};

export default config;
